"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const AdaptiveCards_1 = __importDefault(require("./AdaptiveCards"));
const Conversations_1 = __importDefault(require("./Conversations"));
const DataExport_1 = __importDefault(require("./DataExport"));
const Favorites_1 = __importDefault(require("./Favorites"));
const Companies_1 = __importDefault(require("./Companies"));
const Everyone_1 = __importDefault(require("./Everyone"));
const Webhooks_1 = __importDefault(require("./Webhooks"));
const Persons_1 = __importDefault(require("./Persons"));
const Events_1 = __importDefault(require("./Events"));
const Recent_1 = __importDefault(require("./Recent"));
const Groups_1 = __importDefault(require("./Groups"));
const Files_1 = __importDefault(require("./Files"));
const Notes_1 = __importDefault(require("./Notes"));
const Teams_1 = __importDefault(require("./Teams"));
const Chats_1 = __importDefault(require("./Chats"));
const Tasks_1 = __importDefault(require("./Tasks"));
class Index {
    constructor(parent) {
        this.parent = parent;
        this.rc = parent.rc;
    }
    path() {
        return `${this.parent.path()}/v1`;
    }
    tasks(taskId = null) {
        return new Tasks_1.default(this, taskId);
    }
    chats(chatId = null) {
        return new Chats_1.default(this, chatId);
    }
    teams(chatId = null) {
        return new Teams_1.default(this, chatId);
    }
    notes(noteId = null) {
        return new Notes_1.default(this, noteId);
    }
    files() {
        return new Files_1.default(this);
    }
    groups(groupId = null) {
        return new Groups_1.default(this, groupId);
    }
    recent() {
        return new Recent_1.default(this);
    }
    events(eventId = null) {
        return new Events_1.default(this, eventId);
    }
    persons(personId = null) {
        return new Persons_1.default(this, personId);
    }
    webhooks(webhookId = null) {
        return new Webhooks_1.default(this, webhookId);
    }
    everyone() {
        return new Everyone_1.default(this);
    }
    companies(companyId = null) {
        return new Companies_1.default(this, companyId);
    }
    favorites() {
        return new Favorites_1.default(this);
    }
    dataExport(taskId = null) {
        return new DataExport_1.default(this, taskId);
    }
    conversations(chatId = null) {
        return new Conversations_1.default(this, chatId);
    }
    adaptiveCards(cardId = null) {
        return new AdaptiveCards_1.default(this, cardId);
    }
}
exports.default = Index;
//# sourceMappingURL=index.js.map